import { useState } from "react";
import { RotateCcw, CalendarClock, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Dubai is UTC+4 with no DST.
const dubaiNowLocal = () => new Date(Date.now() + 4 * 3600 * 1000).toISOString().slice(0, 16);
const fmt = (v) => v.replace("T", " ");

export function RevertControls({ section, label, scheduledAt, saving, onReset, onSchedule }) {
  const [value, setValue] = useState(scheduledAt || "");
  const tid = `admin-${section}`;

  const reset = () => {
    if (window.confirm(`Reset ${label} to the original?`)) onReset(section);
  };
  const schedule = () => {
    if (!value) return toast.error("Pick a date & time first");
    if (value <= dubaiNowLocal()) return toast.error("Pick a future date & time (Dubai time)");
    return onSchedule(value);
  };
  const clear = () => {
    setValue("");
    onSchedule("");
  };

  return (
    <div className="space-y-2 rounded border p-3 bg-slate-50" data-testid={`${tid}-revert-controls`}>
      <Button variant="outline" onClick={reset} disabled={saving} data-testid={`${tid}-reset-btn`}>
        <RotateCcw size={14} /> RESET to original {label}
      </Button>
      <Label className="block text-xs pt-1">
        <CalendarClock size={12} className="inline mr-1" />
        Auto-revert on date (optional, Dubai time)
      </Label>
      <div className="flex flex-wrap gap-2">
        <Input
          type="datetime-local"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="h-9 w-auto"
          data-testid={`${tid}-revert-at`}
        />
        <Button size="sm" onClick={schedule} disabled={saving} data-testid={`${tid}-revert-save`}>
          Schedule
        </Button>
        {scheduledAt && (
          <Button size="sm" variant="ghost" onClick={clear} disabled={saving} data-testid={`${tid}-revert-clear`}>
            <X size={14} /> Clear
          </Button>
        )}
      </div>
      <p className="text-[11px] text-muted-foreground" data-testid={`${tid}-revert-status`}>
        {scheduledAt
          ? `Scheduled: reverts to the original ${label} on ${fmt(scheduledAt)} (Dubai time).`
          : "No auto-revert scheduled."}
      </p>
    </div>
  );
}
